import { render } from "./ManagePartner.vue?vue&type=template&id=42a0d8ba&scoped=true"
import script from "./ManagePartner.vue?vue&type=script&lang=js"
export * from "./ManagePartner.vue?vue&type=script&lang=js"

import "./ManagePartner.vue?vue&type=style&index=0&id=42a0d8ba&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1919945302/src/app.tamildata.org/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42a0d8ba"]])

export default __exports__